// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2KB34","rootSmall":"AddTileButton_rootSmall__1MCiS"};